module.exports = __webpack_public_path__ + "media/images/flags/16/Tunisia-a21359f4f154e1b13cc036c395299f52.png";